// @flow strict

import * as React from "react";

import NavbarSection from "../components/Navbar";
import BackToTop from "../components/BackToTop";
import FloatingCart from "../components/FloatingCart";

function ClientLayout({ children }) {
  return (
    <div className="relative w-full overflow-x-hidden max-w-screen-2xl mx-auto">
      <NavbarSection />

      <main className="mt-16">{children}</main>
      {/* <BackToTop /> */}
      <FloatingCart />
    </div>
  );
}

export default ClientLayout;